import { z } from "zod";

export const sessionsCountSchema = z.object({
  count: z.number(),
});

export type SessionsCount = z.infer<typeof sessionsCountSchema>;
